/* hs-eslint ignored failing-rules */

'use es6';

import I18n from 'I18n';
import * as FormsService from 'FormsUI/api/Forms';
import { deleteFormDraft as removeFormDraft } from 'FormsUI/api/FormDrafts';
import { fetchFormDefinition } from './FormDefinition';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { FormErrors, parseFormError } from 'FormsUI/api/Forms';
import { DELETE_UNPUBLISHED_CHANGES } from 'FormsUI/constants/TrackingInteractionKeys/Editor/Global';
function createAction(name) {
  return `@@formDeletion/${name}`;
}
export const REQUEST_FORM_DELETION = createAction('REQUEST_FORM_DELETION');
export const SUCCEED_DELETING_FORM = createAction('SUCCEED_DELETING_FORM');
export const FAIL_DELETING_FORM = createAction('FAIL_DELETING_FORM');
export const RESET_FORM_DELETION_STATE = createAction('RESET_FORM_DELETION_STATE');
const SUCCEED_DELETING_FORM_DRAFT = createAction('SUCCEED_DELETING_FORM_DRAFT');
const FAIL_DELETING_FORM_DRAFT = createAction('FAIL_DELETING_FORM_DRAFT');
export const resetFormDeletionState = () => ({
  type: RESET_FORM_DELETION_STATE
});
const succeedDeletingForm = () => ({
  type: SUCCEED_DELETING_FORM,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('deletionDialog.successMessage')
    }
  }
});
const succeedDeletingFormDraft = () => ({
  type: SUCCEED_DELETING_FORM_DRAFT,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('editor.form.deleteDraftSuccess')
    }
  }
});
const failedDeletingFormDraft = () => ({
  type: FAIL_DELETING_FORM_DRAFT,
  meta: {
    notification: {
      type: 'error',
      message: I18n.text('editor.form.deleteDraftError')
    }
  }
});
const failDeletingForm = ({
  reason = FormErrors.UNKNOWN
}) => ({
  type: FAIL_DELETING_FORM,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('deletionDialog.deletionFailureHeading'),
      message: I18n.text(`deletionDialog.deletionFailureMessages.${reason}`)
    }
  }
});
export function deleteFormDraft(guid) {
  return dispatch => {
    removeFormDraft(guid).then(() => {
      trackEditorInteraction(DELETE_UNPUBLISHED_CHANGES);
      dispatch(succeedDeletingFormDraft());
      dispatch(fetchFormDefinition(guid));
    }, () => {
      dispatch(failedDeletingFormDraft());
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export const deleteForms = (guids = []) => dispatch => {
  dispatch({
    type: REQUEST_FORM_DELETION
  });
  return FormsService.deleteForms(guids).then(() => {
    dispatch(succeedDeletingForm());
  }, xhr => {
    dispatch(failDeletingForm(parseFormError(xhr)));
  });
};